import {connect, MapDispatchToPropsObject} from 'react-redux';
import {IStore} from '../../../redux/auth/reducers';
import {userLogin as login} from '../../../redux/auth/actions';
import {IAuthSignInConnected} from './types';
import {AuthSignIn as Container} from './sign-in';
import {
  getFirstAllowedErrorMessage,
  getConnectionRefusedError,
  getSignInApiError,
  FACEBOOK,
  GOOGLE,
} from '../service';
import {USER_NOT_FOUND} from '../../../utils/API-errors';

const overrides = {
  [USER_NOT_FOUND]: "Your account doesn't exist yet, please sign up first",
};

const mapStateToProps = ({auth}: IStore): IAuthSignInConnected => ({
  connectionRefusedError: getConnectionRefusedError(auth.provider, auth.apiErrors),
  socialError: [FACEBOOK, GOOGLE].includes(auth.provider) && getFirstAllowedErrorMessage(auth.apiErrors, undefined, overrides),
  isLoading: auth.isLoading,
  apiError: getSignInApiError(auth.provider, auth.apiErrors),
});

const mapDispatchToProps: MapDispatchToPropsObject = {
  login,
};

export const AuthSignIn = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Container);
